import React from "react";
import styled from "styled-components";

const RemoveButton = ({ setOpenModal}) => {
    return(
        <Button onClick={()=>setOpenModal(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px"
                 width="24px"
                 viewBox="0 0 24 24"  fill="#E9405B"><path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"/>
            </svg>
        </Button>
    )
}

const Button = styled.button`
  border: none;
  background: none;
  
  svg{
    height: auto;
  }
  &:hover {
    cursor: pointer;
    svg {
      fill: rgba(233, 64, 91, 0.6);
    }
  }
`

export default RemoveButton;